





























































































































import { Vue, Component, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Enums/Data
import { DynamicSettingsFieldTypes } from "@/data/enums/fields";

// Types
import { IGroupField } from "@/models/settings";

@Component
export default class DynamicCategoryField extends Vue {
  // Props
  @Prop({ required: true })
  public readonly value!: any;

  @Prop({ required: true })
  public readonly field!: IGroupField;

  @Prop({ required: true })
  public readonly fieldName!: string;

  @Prop({ default: false })
  public readonly isDisabled!: boolean;

  @Prop({ default: false })
  public readonly isRequired!: boolean;

  public fieldTypes = DynamicSettingsFieldTypes;

  // Computed

  public get placeholder() {
    const defaultFieldValue = _.get(this.field, "default_value", null);
    if (!_.isNull(defaultFieldValue)) return defaultFieldValue;

    return this.$t("_placeholder.enter_your_field_value", {
      name: this.fieldLabel.toLowerCase()
    });
  }

  public get fieldModel() {
    return this.value;
  }

  public set fieldModel(value) {
    this.$emit("input", value);
  }

  public get isSlider() {
    return _.get(this.field, "field_type") === this.fieldTypes.SLIDER;
  }

  public get fieldType() {
    return _.get(this.field, "field_type");
  }

  public get fieldIsRequired() {
    return _.get(this.field, "required");
  }

  public get defaultOptions() {
    switch (this.fieldType) {
      case DynamicSettingsFieldTypes.MULTIPLE:
      case DynamicSettingsFieldTypes.RADIO:
      case DynamicSettingsFieldTypes.SELECT:
        return [];
      default:
        return this.field.options;
    }
  }

  public get fieldOptions() {
    return _.get(this.field, "options", this.defaultOptions);
  }

  public get fieldLabel() {
    return _.get(this.field, "name", "");
  }

  public get getRules() {
    return _.merge(
      {
        required: this.fieldIsRequired
      },
      this.isSlider
        ? {
            min_value: _.get(this.field, "options.min.value", 0),
            max_value: _.get(this.field, "options.max.value", 30)
          }
        : {}
    );
  }

  public get getSwitchLabel() {
    const options = _.get(this.field, "options");
    if (options) {
      return _.get(_.find(options, ["value", this.fieldModel]), "label", "");
    }
    return _.get(this.field, "name", "");
  }
}
